import { render, staticRenderFns } from "./children_layout.vue?vue&type=template&id=088faf9c&scoped=true"
import script from "./children_layout.vue?vue&type=script&lang=ts"
export * from "./children_layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088faf9c",
  null
  
)

export default component.exports